<template>
    <div class="stop-wrap" v-loading="loading">
        <div class="title">停止分成设置</div>
        <div class="content">
            请确认停止专辑
            <span><{{ $route.query.trackName }}></span>
            中的
            <span>《{{ $route.query.albumName }}》</span>
            <span>{{ $route.query.toCpRealName }}</span>
            的
            <span>{{ $route.query.rate }}%</span>
            分成
        </div>
        <div class="tips">
            <p>你需要了解：</p>
            <div>1.停止分成后，对方的分成份额将会由你受益</div>
            <div>2.停止分成后，系统会通知对方</div>
        </div>
        <div class="footer">
            <el-button @click="handleCancel">我再考虑下</el-button>
            <el-button type="danger" @click="submit" style="margin-left: 20px;">确认停止分成</el-button>
        </div>
    </div>
</template>

<script>
import {cpSplitRuleStop} from '@/api/distribute';

export default {
    data() {
        return {
            loading: false
        };
    },
    methods: {
        handleCancel() {
           this.$router.push(`/manage/distribute/initiate`);//发起
        },
        async submit() {
            try {
                this.loading = true;
                const formData = new FormData();
                formData.append('ruleId', this.$route.query.ruleId);
                const res = await cpSplitRuleStop(formData);
                const {state, msg} = res.data;
                if (!state) return this.$message.error(msg || '停止分成失败');
                this.$message.success('停止分成成功');
            } catch (error) {
                this.$message.error('停止分成失败');
            } finally {
                this.loading = false;
                this.handleCancel();
            }
        },
    },
};
</script>
<style lang="scss">
.stop-wrap {
    padding: 0px 40px 360px 40px;
    background-color: $--color-white;
    overflow: hidden;
    border-radius: 0 0 10px 10px ;
    .title {
        padding: 40px 40px 0;
        font-size: 24px;
        color: #000;
        line-height: 24px;
        font-weight: 600;
        border-radius: 10px 10px 0 0;
        background-color: #fff;
        overflow: hidden;
        position: relative;
    }
    .content {
        padding: 40px 40px 0;
    }
    .tips {
        padding: 40px 40px 0;
        p {
            font-weight: bold;
        }
        div {
            padding-top: 10px;
        }
    }
    .footer {
        padding: 80px 0 0 40px;
    }
}
</style>
